<template>
  <div class="race-question">
    <sweet-modal ref="addRace" v-on:close="onClose">
      <span ><p style="color: red;margin-bottom:20px">Add Race</p></span>

      <div class="editFields"><span>Race Id</span> <input type = "number" v-model="raceId" id="newdistance"  name="newdistance" Placeholder="" style="width: 50%;"></div>
      <div class="editFields">Distance <input type = "number" v-model="newdistance" id="newdistance"  name="newdistance" Placeholder="" style="width: 45%;margin-left: 15px;"> Km</div>
   
      <div v-if ="error" class="error-msg"><span ><p style="color: red;">Not a valid Race Id !</p></span></div>
      <div>
          <br/>
          <button class="btn btn--primary"  v-on:click="Save(raceId,newdistance)" style="float:none">Save</button>
      </div>
    </sweet-modal>  
  </div>
  
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'add-race-data',
    data: () => ({
        raceId:'',
        newdistance:0,
        //finishDate: '',
        // newRunnerRaceResume: {
        //  	  distance:0.00,
        //     paceAVG:0.00,
        //     timeTotal:0,
        //     runner:{},
        //     raceResume: {
        //       id:''
        //     }
        // },
        error:false

    }),
    props:{
            race: {
                type:Object
            },
            show:false,
            runnerId:''
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
        onClose() {
                this.$emit('closed', true)
        },
        openEditModal() {
          this.raceId='',
          this.newdistance=0,
          this.error=false
          // this.newRunnerRaceResume= {
         	//   distance:0.00,
          //   paceAVG:0.00,
          //   timeTotal:0,
          //   runner:{},
          //   raceResume: {
          //     id:''
          //   }
          // },
          this.$refs.addRace.open()
          console.log("runnerid---",this.runnerId)         
          // this.newRunnerRaceResume.runner = {
          //   id:this.runnerId
          // }
          // this.newRunnerRaceResume.raceResume= {
          //   "id": this.race.runnerRaceResume.raceResume.id
          // }
          //  console.log("his.newRunnerRaceResume---",this.newRunnerRaceResume)

          // this.newRunnerRaceResume= {
         	//   distance:this.race.runnerRaceResume.distance,
          //   paceAVG:this.race.runnerRaceResume.paceAVG,
          //   timeTotal:this.race.runnerRaceResume.timeTotal,
          // }
        },
        async Save (raceId,distance) { 
        var raceInFb = await db.ref(`/${this.$fbDbEntry}/${raceId}`).once('value')

        if(raceInFb.val()==null){
          console.log("innn")
          this.error=true
          return
        }
        var raceResumeId =  raceInFb.val().raceResumeId
        console.log("---", raceInFb.val().raceResumeId )
          var data = {
              distance:parseFloat(distance)*1000,
              paceAVG:0,
              timeTotal:0,
              runner:{
                id:this.runnerId
              },
              raceResume: {
                id:raceResumeId
              }
          }
           console.log("data---",data)
            RunnersByRaceService.addRaceResume(data).then((response) => {
              this.error=false
              console.log("response---",response)
              this.$emit('saved', response.data)
              this.$refs.addRace.close()
            },
            error =>{
              console.log("error---",error)
              this.error=true
            })
        }
    },
    created() {
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    },
    components: {
      SweetModal
    }
  }
</script>
<style>
  .edit {
      background: red;
      padding: 0px 12px 0px 12px;
      color: white;
      border-radius: 10px;
      border-width: 1px;
      font-weight: bold;
    }

    #newdistance {
      height: 50px;
      border-radius: 10px;
      font-size: x-large;
      margin-left: 25px;
      text-align: center
    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0; 
    }
    input:focus{
        outline: none;
    }
    .editFields{
      margin-bottom: 10px
    }
    .error-msg {
    margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// AddRaceData.vue?4a3042a7